import { r as reactExports, u as useConfigContext, R as React, c as clsx } from './product-card-full-BdqRuW4I.js';
import { S as Swiper, A as A11y, N as Navigation, P as Pagination, a as Scrollbar, b as Autoplay } from './autoplay-BQYEHWVI.js';
import './api-B1oX1Rmz.js';
import './js.cookie-QHAcXMw2.js';
import './facets-CNKYyM-4.js';

Swiper.use([A11y, Navigation, Pagination, Scrollbar, Autoplay]);

 





const Carousel = reactExports.forwardRef(
  ({ title, slides, swiperNavigationClass = 'absolute left-0 right-0 top-0 grid grid-cols-4 gap-8' }, ref) => {
    const { translations } = useConfigContext();
    const id = reactExports.useMemo(() => {
      const now = new Date().getTime();

      return Math.floor(Math.random() * now).toString(16);
    }, []);
    const [swiperInstance, setSwiperInstance] = reactExports.useState(null);
    const swiperDomRefCB = reactExports.useCallback(
      (node) => {
        if (node) {
          const swiperInstance = new Swiper(node, {
            slidesPerView: 2,
            spaceBetween: 16,
            loop: false,
            navigation: {
              nextEl: `.swiper-button-next-${id}`,
              prevEl: `.swiper-button-prev-${id}`,
            },
            pagination: {
              el: `.swiper-pagination-${id}`,
              type: 'bullets',
              clickable: true,
            },
            breakpoints: {
              '768': { slidesPerView: 3, spaceBetween: 32 },
              '1024': { slidesPerView: 4, spaceBetween: 32 },
            },
          });

          setSwiperInstance(swiperInstance);
        }
      },
      [id]
    );

    reactExports.useEffect(() => {
      return () => {
        if (swiperInstance) {
          swiperInstance.destroy();
        }
      };
    }, [swiperInstance]);

    return (
      React.createElement('div', { ref: ref, className: "container overflow-hidden" ,}
        , title && (
          React.createElement('header', { className: "container__header " ,}
            , React.createElement('h2', { className: "container__title h3 text-left leading-6 md:text-left md:leading-8"     ,}, title)
          )
        )
        , React.createElement('div', { className: "container__content overflow-hidden text-left"  ,}
          , React.createElement('div', { className: "relative",}
            /* Swiper */
            , React.createElement('div', { ref: swiperDomRefCB, className: "swiper swiper-pagination-active" ,}
              /* Swiper Wrapper */
              , React.createElement('div', { className: "swiper-wrapper",}
                , slides.map((slide, index) => (
                  React.createElement('div', {
                    key: `${id}-${index}`,
                    className: "swiper-slide -mb-1 h-auto w-full sm:w-1/2 md:w-1/3 lg:w-1/4"      ,
                    'data-swiper-slide-index': index + 1,}

                    , slide()
                  )
                ))
              )
              /* Swiper pagination */
              , React.createElement('div', { className: `swiper-pagination swiper-pagination-${id} md:hidden`,})
            )
            /* Swiper navigation */
            , React.createElement('div', { className: clsx(swiperNavigationClass),}
              , React.createElement('div', { className: "col-span-4 sm:col-span-2 lg:col-span-1"  ,}
                , React.createElement('div', { className: "aspect-[1/1]",})
              )
              , React.createElement('button', {
                type: "button",
                className: `swiper-button-prev swiper-button-prev-${id} -left-5 transition-all duration-200 hover:bg-primary hover:opacity-100 aria-disabled:hidden lg:-left-[3.25rem]`,
                'aria-label': translations.accessibility.previousSlide,}

                , React.createElement('svg', {
                  className: "icon icon--chevron-left w-5"  ,
                  xmlns: "http://www.w3.org/2000/svg",
                  'aria-hidden': "true",
                  role: "presentation",
                  viewBox: "0 0 20 20"   ,}

                  , React.createElement('path', {
                    d: "M13.0875 5.92917L9.27083 9.75417L13.0875 13.5792L11.9125 14.7542L6.91249 9.75417L11.9125 4.75417L13.0875 5.92917Z"       ,
                    fill: "currentColor",}
)
                )
              )
              , React.createElement('button', {
                type: "button",
                className: `swiper-button-next swiper-button-next-${id} -right-5 transition-all duration-200 hover:bg-primary hover:opacity-100 aria-disabled:hidden lg:-right-[3.25rem]`,
                'aria-label': translations.accessibility.nextSlide,}

                , React.createElement('svg', {
                  className: "icon icon--chevron-right w-5"  ,
                  xmlns: "http://www.w3.org/2000/svg",
                  'aria-hidden': "true",
                  role: "presentation",
                  viewBox: "0 0 20 20"   ,}

                  , React.createElement('path', { d: "M7 13.825L10.8167 10L7 6.175L8.175 5L13.175 10L8.175 15L7 13.825Z"       , fill: "currentColor",})
                )
              )
            )
          )
        )
      )
    );
  }
);

export { Carousel as C };
